var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{staticClass:"el-menu-vertical-demo",attrs:{"default-active":_vm.defaultId,"default-openeds":_vm.openIds},on:{"open":_vm.handleOpen,"close":_vm.handleClose,"select":_vm.selectSub}},[_vm._l((_vm.list),function(item){return [_c('sub-item',{attrs:{"item":item}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }